module.exports = __webpack_public_path__ + "img/1561577187.5b6cacd5.jpg";